import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MiniBadgeProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-mini-badge',
  template: '<div></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: { class: 'flex overflow-hidden' },
  imports: [CommonModule],
})
export class BlFrontendMiniBadgeComponent extends BlFrontendBaseComponent<MiniBadgeProps> {
  @Input() variant?: MiniBadgeProps['variant'] = 'neutral';
  @Input() emphasis?: MiniBadgeProps['emphasis'] = 'subtle';
  @Input() ariaLabel?: MiniBadgeProps['ariaLabel'];

  protected override getComponentName(): string {
    return 'MiniBadge';
  }

  protected override getProps(): MiniBadgeProps {
    return {
      ariaLabel: this.ariaLabel,
      variant: this.variant,
      emphasis: this.emphasis,
    };
  }
}
